import React, { useState, useEffect } from 'react';

interface ButtonProps {
  buttonClass: string;
  ariaLabel: string;
  label: string;
  handleButtonClick: () => void;
  tabIndex?:number;
}
const Button: React.FC<ButtonProps> = ({
  buttonClass,
  ariaLabel,
  label,
  handleButtonClick,
  tabIndex,
}) => {
  useEffect(() => {});

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleButtonClick();
    }
  };

  return (
    <button
      className={`${buttonClass}`}
      onClick={handleButtonClick}
      onKeyPress={handleKeyPress}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
    >
      {label}
    </button>
  );
};

export default Button;
